import { AWS_ENDPOINT_URL } from '@sigma/env/resources.js';
/**
 * Constructs the base OAuth2 URL for a Cognito User Pool domain.
 *
 * On AWS, the domain is like `{prefix}.auth.{region}.amazoncognito.com`
 * and OAuth2 endpoints are at `https://{domain}/oauth2/...`.
 *
 * On LocalStack, OAuth2 endpoints use a different path format
 * under the LocalStack endpoint URL, ignoring the domain entirely.
 */
export function getCognitoOAuthUrl(domain) {
    if (!AWS_ENDPOINT_URL) {
        return `https://${domain}`;
    }
    return `${AWS_ENDPOINT_URL}/_aws/cognito-idp`;
}
//# sourceMappingURL=getCognitoOAuthUrl.js.map